import React from 'react'

const HeaderLogout = () => {
    return (
        <div>
            <h3>This is an Logout Header</h3>
        </div>
    )
}

export default HeaderLogout
